import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

type AtomWithBroadcastKey = string;
type AtomWithBroadcastValue = object | string | number | boolean | null | unknown;
interface AtomWithBroadCastOptions {
    storeInLocalStorage?: boolean;
}
interface Update {
    fromOnMessage: boolean;
    value: AtomWithBroadcastValue;
}

const atomWithBroadcast = (key: AtomWithBroadcastKey, initialValue: AtomWithBroadcastValue, options?: AtomWithBroadCastOptions) => {
    const broadcastChannel = new BroadcastChannel(key);
    const baseAtom = options?.storeInLocalStorage ? atomWithStorage(key, initialValue) : atom(initialValue);
    const listeners = new Set<(event: MessageEvent) => void>();

    const broadcastAtom = atom(
        (get) => get(baseAtom),
        (get, set, update: Update) => {
            if (!update.fromOnMessage) {
                broadcastChannel.postMessage(update.value);
            }
            set(baseAtom, update.value);
        },
    );
    broadcastAtom.onMount = (setAtom) => {
        const listener = (event: MessageEvent) => {
            setAtom({ fromOnMessage: true, value: event.data });
        };
        listeners.add(listener);
        broadcastChannel.onmessage = (event) => {
            listeners.forEach((f) => f(event));
        };
        return () => {
            listeners.delete(listener);
        };
    };

    return atom(
        (get) => get(broadcastAtom),
        (get, set, update) => {
            set(broadcastAtom, { fromOnMessage: false, value: update });
        },
    );
};

export default atomWithBroadcast;
